window.DLHelper = {
    measureProductClick: (id, currencyCode) => {
        if (!Boolean(id) || id == 'null') {
            return;
        }
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: 'productClick',
            ecommerce: {
                currencyCode,
                productId: id,
                click: {
                    products: [{id}],
                },
                // eventCallback: function () {
                //     window.location = url;
                // }
            }
        });
    },

    measureProductImpressions: (id, currencyCode) => {
        if (!Boolean(id) || id == 'null') {
            return;
        }
        window.dataLayer = window.dataLayer || [];

        setTimeout(() => {
            window.dataLayer.push({
                event: 'productImpression',
                ecommerce: {
                    currencyCode: currencyCode,
                    productId: id,
                    impressions: [{id}],
                }
            });
        });

        if (!('fbq' in window)) {
            return;
        }

        setTimeout(() => {
            fbq('track', 'ViewContent', {
                currency: currencyCode,
                content_type: 'product',
                content_ids: id,
            });
        });
    },

    measureAddToCart: (id, currencyCode) => {
        if (!Boolean(id) || id == 'null') {
            return;
        }
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: currencyCode,
                productId: id,
                add: {
                    products: [{id}],
                },
            }
        });

        if (!('fbq' in window)) {
            return;
        }

        fbq('track', 'AddToCart', {
            currency: currencyCode,
            content_type: 'product',
            contents: [{id, quantity: 1}],
        });
    },

    measureRemoveFromCart: (id) => {
        if (!Boolean(id) || id == 'null') {
            return;
        }
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                productId: id,
                remove: {
                    products: [{id}],
                },
            }
        });
    },
};

let ProductEnhancer = {
    init: (options) => {
        let products = document.querySelectorAll(`.product`);

        products.forEach(productElement => {
            if (productElement.classList.contains('is-product-footer')) {
                return;
            }
            if (productElement.classList.contains('is-product-label')) {
                return;
            }

            let id = productElement.getAttribute('data-product-id');
            let url = productElement.getAttribute('data-product-url');

            // let addToCartElement = productElement.querySelector(`.add-to-cart`);
            // if (addToCartElement) {
            //     productElement.addEventListener('mouseover', () => {
            //         addToCartElement.classList.remove('is-invisible');
            //     });
            //     productElement.addEventListener('mouseout', () => {
            //         addToCartElement.classList.add('is-invisible');
            //     });
            // }

            let priceElement = productElement.querySelector(`.price`);
            if (priceElement) {
                priceElement.setAttribute('data-product-id', id);
                priceElement.setAttribute('data-product-url', url);
            }


            let aAddToCartElement = productElement.querySelector(`a.add-to-cart`);
            if (aAddToCartElement) {
                aAddToCartElement.addEventListener('click', (e) => {
                    DLHelper.measureAddToCart(id);
                    // window.location = e.currentTarget.getAttribute('href');
                });
            }
            let aRemoveFromCartElement = productElement.querySelector(`a.remove-from-cart`);
            if (aRemoveFromCartElement) {
                aRemoveFromCartElement.addEventListener('click', (e) => {
                    DLHelper.measureRemoveFromCart(id);
                    // window.location = e.currentTarget.getAttribute('href');
                });
            }

            let formAddToCartElement = productElement.querySelector(`form.add-to-cart`);
            if (formAddToCartElement) {
                formAddToCartElement.addEventListener('submit', () => {
                    DLHelper.measureAddToCart(id);
                });
            }
            let formRemoveFromCartElement = productElement.querySelector(`form.remove-from-cart`);
            if (formRemoveFromCartElement) {
                formRemoveFromCartElement.addEventListener('submit', () => {
                    DLHelper.measureRemoveFromCart(id);
                });
            }

            if (productElement.classList.contains('is-product-link')) {
                productElement.addEventListener('click', () => {
                    DLHelper.measureProductClick(id, currencyCode);
                    window.location = url;
                });
                // let imageElement = productElement.querySelector(`.image`);
                // if (imageElement)
                //     imageElement.classList.add('has-cursor-pointer');
                // imageElement.addEventListener('click', () => {
                //     DLHelper.measureProductClick(id, currencyCode);
                //     window.location = url;
                // });
                // let aTitleElement = productElement.querySelector(`a.title`);
                // if (aTitleElement) {
                //     aTitleElement.addEventListener('click', () => {
                //         DLHelper.measureProductClick(id, currencyCode);
                //         // window.location = url;
                //     });
                // }
            } else if (productElement.classList.contains('is-product-overview')) {
                let galleryElement = productElement.querySelector(`.tile.gallery`);
                if (galleryElement)
                    galleryElement.classList.add('has-cursor-pointer');
                galleryElement.addEventListener('click', () => {
                    DLHelper.measureProductClick(id, currencyCode);
                    window.location = url;
                });
            }
        })
    }
};

export default ProductEnhancer;